import { Injectable } from '@angular/core';
import { isObjectLike, map } from 'lodash';
import { FILTER_REGEX, FILTER_STRINGS } from 'i2g-ng-utils';

@Injectable()
export class LoggerStore {
  private _LOGS = {};

  getLogs() {
    return map(this._LOGS, (messages: any[][]) => {
      return messages.map((m) =>
        map(m, (v) => (isObjectLike(v) ? JSON.stringify(v) : v))
      );
    });
  }

  pushLog(...messageParts) {
    const stringMessage = JSON.stringify(messageParts);
    // avoid saving sensitive message
    for (let i = 0; i < FILTER_STRINGS.length; i++) {
      if (stringMessage.toLowerCase().includes(FILTER_STRINGS[i])) return;
    }
    for (let i = 0; i < FILTER_REGEX.length; i++) {
      if (stringMessage.match(FILTER_REGEX[i])) return;
    }

    const key = Date.now();

    if (this._LOGS.hasOwnProperty(key)) {
      this._LOGS[key].push(messageParts);
    } else {
      this._LOGS[key] = [messageParts];
    }
  }
}
